<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{ 'auth.change_password' | translate }}
    v-card-content
      div.mb-3
        v-text-field(
          :focus="true"
          :label="'auth.new_password' | translate"
          v-model="form.password")
        span.hint(
          v-if="showPasswordLengthHint")
          | (мінімальна довжина пароля 8 символів)
      v-text-field(
        :label="'auth.repite_password' | translate"
        v-model="form.password_repeat")
    v-card-actions
      v-btn(
        :disabled="!isPasswordValid"
        :loading="loading"
        @click="onSubmit")
        | {{ $t('base.change') }}
</template>

<script>
export default {
  name: 'ChangePassword',

  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    form: {
      password: null,
      password_repeat: null
    }
  }),

  computed: {
    showPasswordLengthHint () {
      return this.form.password &&
        this.form.password.length < 8
    },

    isPasswordValid () {
      return this.form.password &&
        this.form.password.length >= 8 &&
        this.form.password === this.form.password_repeat
    }
  },

  methods: {
    onSubmit () {
      const payload = {
        password: this.form.password
      }
      this.$emit('submit', payload)
    }
  }
}
</script>

<style scoped>
.hint {
  opacity: .5;
  display: block;
  font-size: 12px;
  font-weight: 300;
  margin-top: 1rem;
}
</style>
